import { defineMessage, MessageDescriptor } from 'react-intl';
import { ArtistPortalPlaylistCurator } from 'fym-shared/src/smartlinks/artistPortals';

/** Who made the playlist. The ids of Insights stay, so the native apps keep their translations. */
export const streamingCuratorMessages: Record<ArtistPortalPlaylistCurator, MessageDescriptor> = {
  [ArtistPortalPlaylistCurator.editorial]: defineMessage({
    id: 'app.sml.insights.playlists.curator.editorial',
    defaultMessage: 'Editorial',
  }),
  [ArtistPortalPlaylistCurator.listener]: defineMessage({
    id: 'app.sml.insights.playlists.curator.listener',
    defaultMessage: 'Listener',
  }),
  [ArtistPortalPlaylistCurator.algorithmic]: defineMessage({
    id: 'app.sml.insights.playlists.curator.algorithmic',
    defaultMessage: 'Algorithmic',
  }),
  [ArtistPortalPlaylistCurator.other]: defineMessage({
    id: 'app.sml.insights.playlists.curator.other',
    defaultMessage: 'Other',
  }),
};
